// @flow
import * as React from 'react';
import { Button, Box } from 'grommet';
import styled from 'styled-components';

type Props = {
    title: string,
    link: string,
    onClick: Function,
}

const StyledBreadcrumb = styled(Button)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const BreadcrumbItem = (props: Props) => {
    const {
        title, link, onClick,
    } = props;

    return (
        <StyledBreadcrumb onClick={() => onClick(link)}>
            {title}
        </StyledBreadcrumb>
    );
};

export default BreadcrumbItem;
